import { render, staticRenderFns } from "./AdminOrganizationUserImport.vue?vue&type=template&id=70f97ad4&scoped=true"
import script from "./AdminOrganizationUserImport.vue?vue&type=script&lang=js"
export * from "./AdminOrganizationUserImport.vue?vue&type=script&lang=js"
import style0 from "./AdminOrganizationUserImport.vue?vue&type=style&index=0&id=70f97ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f97ad4",
  null
  
)

export default component.exports